
import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL

class AgentService {
  /**
   * Get all agents for the current user
   */
  getAgents () {
    return axios.get(API_URL + 'agents')
  }

  /**
   * Get a specific agent by ID
   */
  getAgentById (agentId) {
    return axios.get(API_URL + 'agents/' + agentId)
  }

  /**
   * Create a new agent
   */
  createAgent (agentData) {
    return axios.post(API_URL + 'agents', agentData)
  }

  /**
   * Update an existing agent
   */
  updateAgent (agentId, agentData) {
    return axios.put(API_URL + 'agents/' + agentId, agentData)
  }

  /**
   * Delete an agent
   */
  deleteAgent (agentId) {
    return axios.delete(API_URL + 'agents/' + agentId)
  }

  /**
   * Get agent status
   */
  getAgentStatus (agentId) {
    return axios.get(API_URL + 'agents/' + agentId + '/status')
  }

  /**
   * Assign (or clear) an API key for a specific agent.
   * Pass null to fall back to the scope default.
   */
  setApiKey (agentId, apiKeyId) {
    return axios.patch(API_URL + 'agents/' + agentId + '/api-key', { apiKeyId })
  }

  /**
   * Get available LLM providers
   */
  getAvailableProviders () {
    // This could be from an API or hardcoded for now
    return Promise.resolve({
      data: {
        providers: [
          { name: 'OpenAI', models: ['gpt-3.5-turbo', 'gpt-4', 'gpt-4-turbo'] },
          { name: 'Gemini', models: ['gemini-pro', 'gemini-pro-vision'] }
        ]
      }
    })
  }
}

export default new AgentService()
